import { useState, useCallback, useEffect, useRef } from "react";
import { OnboardingStep } from "./types";
import { TipName } from "shared/datamodel/schemas";
import { useCanvasOnboardingPhase } from "./use-canvas-onboarding";

interface OnboardingFlowProps {
  phases: TipName[];
  getInitialStepId: (phase: TipName) => string | null;
  steps: Map<string, OnboardingStep>;
  onPhaseFinished: (stepId: string | null) => void;
}

export default function OnboardingFlow({ phases, steps, onPhaseFinished, getInitialStepId }: OnboardingFlowProps) {
  const [currentStepId, setCurrentStepId] = useState<string | null>(null);
  const isFirstRender = useRef(true);
  const phase = useCanvasOnboardingPhase(phases);

  const currentStep = steps.get(currentStepId || "");

  const goToStep = useCallback((stepId: string) => {
    setCurrentStepId(null);
    setTimeout(() => setCurrentStepId(stepId), 50);
  }, []);

  const onFinishPhase = useCallback(() => {
    setCurrentStepId(null);
    setTimeout(() => {
      onPhaseFinished(currentStepId);
    }, 50);
  }, [currentStepId, onPhaseFinished]);

  useEffect(() => {
    if (phase) {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        setTimeout(() => {
          setCurrentStepId(getInitialStepId(phase));
        }, 1000);
      } else {
        setCurrentStepId(getInitialStepId(phase));
      }
    }
  }, [phase]);

  if (!currentStep || !phase) {
    return null;
  }

  return <>{currentStep.render({ goToStep, onFinishPhase })}</>;
}
